import { Container } from "@mui/material";
import React, { useEffect, useRef } from "react";

type IGameFrameProps = {
  game_url: string;
  is_demo: boolean;
  user_id: string;
  setIcon: React.Dispatch<React.SetStateAction<boolean>>;
  is_mobile: boolean;
};

export const GameFrame = ({
  game_url,
  is_demo,
  user_id,
  setIcon,
  is_mobile,
}: IGameFrameProps) => {
  useEffect(() => {
    const handleBeforeUnload = (event: any) => {
      if (!is_demo && user_id) {
        const data = {
          event: "page_unload",
          user_id,
        };
        const headers = {
          type: "application/json",
        };
        const blob = new Blob([JSON.stringify(data)], headers);
        navigator.sendBeacon(
          `${process.env.REACT_APP_SERVER_URL}/api/profile/loyalty-update`,
          blob
        );
      }
    };

    const handleVisibilityChange = () => {
      if (document.visibilityState === "hidden" && !is_demo && user_id) {
        const data = {
          event: "page_hidden",
          user_id,
        };
        const headers = {
          type: "application/json",
        };
        const blob = new Blob([JSON.stringify(data)], headers);
        navigator.sendBeacon(
          `${process.env.REACT_APP_SERVER_URL}/api/profile/loyalty-update`,
          blob
        );
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [is_demo, user_id, window, document]);

  return (
    <>
      <iframe
        allowFullScreen={true}
        id="gameFrame"
        referrerPolicy="no-referrer"
        title="game"
        src={game_url}
        style={{
          height: is_mobile ? `var(--real-vh)` : "100%",
          width: "100%",
          border: "none",
        }}
        onLoad={() => {
          setIcon(true);
        }}
      />
    </>
  );
};
